// Centralna polityka hasel. Jedno zrodlo prawdy dla calego systemu.
// Wymagania: min. 8 znakow, co najmniej jedna mala litera, jedna duza litera
// oraz jedna cyfra.

export const PASSWORD_MIN_LENGTH = 8

export const PASSWORD_POLICY_MESSAGE =
  'Hasło musi mieć minimum 8 znaków oraz zawierać małą literę, dużą literę i cyfrę'

/**
 * Sprawdza czy haslo spelnia polityke.
 * @returns null gdy OK, albo komunikat bledu (string) gdy nie spelnia.
 */
export function validatePassword(password: unknown): string | null {
  if (typeof password !== 'string' || password.length === 0) {
    return 'Podaj hasło'
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    return PASSWORD_POLICY_MESSAGE
  }
  if (!/[a-z]/.test(password)) {
    return PASSWORD_POLICY_MESSAGE
  }
  if (!/[A-Z]/.test(password)) {
    return PASSWORD_POLICY_MESSAGE
  }
  if (!/[0-9]/.test(password)) {
    return PASSWORD_POLICY_MESSAGE
  }
  return null
}

/** Wersja boolean dla wygody na froncie. */
export function isPasswordValid(password: unknown): boolean {
  return validatePassword(password) === null
}

/** Pojedyncze wymaganie polityki — do checklisty na zywo. */
export type PasswordRule = { label: string; ok: boolean }

/**
 * Zwraca liste wymagan z informacja czy kazde jest spelnione dla danego hasla.
 * Uzywane do checklisty na zywo na froncie (zaznaczanie spelnionych warunkow).
 */
export function getPasswordChecklist(password: string): PasswordRule[] {
  const pw = typeof password === 'string' ? password : ''
  return [
    { label: 'Minimum 8 znaków', ok: pw.length >= PASSWORD_MIN_LENGTH },
    { label: 'Duża litera', ok: /[A-Z]/.test(pw) },
    { label: 'Mała litera', ok: /[a-z]/.test(pw) },
    { label: 'Cyfra', ok: /[0-9]/.test(pw) },
  ]
}

/**
 * Generuje losowe haslo jednorazowe ktore GWARANTOWANIE spelnia polityke
 * (min. 8 znakow, mala+duza litera+cyfra). Uzywane przy zapraszaniu/resecie
 * hasla pracownika. Pomija znaki latwo mylone (0/O, 1/l/I).
 */
export function generateCompliantPassword(length = 10): string {
  const lower = 'abcdefghijkmnpqrstuvwxyz'
  const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ'
  const digits = '23456789'
  const all = lower + upper + digits
  const pick = (set: string) => set[Math.floor(Math.random() * set.length)]

  const len = Math.max(length, PASSWORD_MIN_LENGTH)
  // Gwarantuj po jednym z kazdej klasy
  const chars = [pick(lower), pick(upper), pick(digits)]
  for (let i = chars.length; i < len; i++) chars.push(pick(all))

  // Tasowanie (Fisher-Yates) zeby wymagane znaki nie byly zawsze na poczatku
  for (let i = chars.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[chars[i], chars[j]] = [chars[j], chars[i]]
  }
  return chars.join('')
}
